var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavItem',{on:{"click":_vm.toggleSearch}},[_c('label',{staticClass:"w-4 cursor-pointer",attrs:{"for":_vm.inputid,"title":_vm.$t('Toggle_Search_Open')}},[_c('SearchIcon')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }